import { Button, FormControl, HorizontalStack, Input, Modal } from '@lego/klik-ui';
import { useEffect, useState } from 'react';
import { validateLabel } from '@/components/file/upload/uploadValidation';

type FileLabelModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (label: string) => void;
  initialLabel: string;
};

export const FileLabelModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialLabel = '',
}: FileLabelModalProps) => {
  const [label, setLabel] = useState(initialLabel);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLabel(initialLabel);
      setError('');
    }
  }, [isOpen, initialLabel]);

  const handleSubmit = () => {
    const validationError = validateLabel(label);
    if (validationError) {
      setError(validationError);
      return;
    }
    onSubmit(label);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>Add a label for your file</Modal.Header>
        <Modal.Body>
          Should only contain lowercase letters, numbers, dots, and underscores
        </Modal.Body>
        <Modal.CloseButton />
        <Modal.Body>
          <FormControl isInvalid={!!error}>
            <FormControl.Label>Label</FormControl.Label>
            <Input
              onChange={(e) => {
                setLabel(e.target.value);
                setError('');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit();
                }
              }}
              placeholder="Enter a label for this file"
              value={label}
            />
            {error && <FormControl.ErrorText>{error}</FormControl.ErrorText>}
          </FormControl>
        </Modal.Body>
        <Modal.Footer>
          <HorizontalStack spacing={2}>
            <Button onClick={onClose} variant="outline">
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Upload</Button>
          </HorizontalStack>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
